<template>
  <el-dialog :title="modalInfo.title" :visible.sync="modalInfo.isShow" :close-on-click-modal="false" v-if="modalInfo.isShow" width="30%">
    <el-form :model="modalInfo.form" :rules="rules" ref="ruleForm" class="keySettingForm">
      <el-form-item label="关键词" prop="keywordname" :label-width="formLabelWidth" >
        <el-input v-model.trim="modalInfo.form.keywordname" autocomplete="on" size="small"></el-input>
      </el-form-item>
      <!-- <el-form-item label="CAT值" prop="catid" :label-width="formLabelWidth">
        <el-input v-model.number="modalInfo.form.catid" size="small"></el-input>
      </el-form-item> -->
      <el-form-item label="备注说明" :label-width="formLabelWidth">
        <el-input type="textarea" v-model.trim="modalInfo.form.memo" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" class="cancel" @click="modalInfo.isShow = false">取 消</el-button>
      <el-button size="small" type="primary" class="confirm" @click="confirmClick()">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
// 输入框验证为数字可以为空
let validatorNumber = (rule,value,callback)=>{
  if(value){
    if((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) == false){
      callback(new Error("CAT值必须为数字"));
    }else{
      callback();
    }
  }else{
    callback();
  }
}
export default {
    name:'newAddModel',
    props:{
      modalInfo:{
          type:Object,
          default:() =>{}
      }
    },
    data(){
      return {
          formLabelWidth:"100px",
          rules: {
            keywordname: [{ required: true, message: '关键词不能为空', trigger: 'blur' }],
            catid: [{ required: false,validator:validatorNumber,trigger:'change'}],
          }
      }
    },
    methods:{
      confirmClick(){
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.reqNewAdd();
          } else {
            return false;
          }
        });
      },
      // 新增/编辑请求
      reqNewAdd(){
        fetch({
          url: "/hcm/hcmKeywords/save",
          method: "post",
          data: this.modalInfo.form,
          noFormat: true,
          responseType: "text"
        })
        .then(result => {
          let res = JSON.parse(result);
          if(res.status == '10000'){
            this.$message({
              message: '操作成功！',
              type: res.message
            })
            this.modalInfo.isShow = false;
            this.$emit("reqTableData")
          }else{
            this.$message.error(res.message?res.message:'操作失败！');
          }
        })
        .catch(err => {
          console.log(err)
        })
      }
    }
}
</script>
<style lang="scss">
 
.keySettingForm{
	padding: 0!important;
}
</style>
